import { typeSubjectOccorence } from "../constants";
import { SupportType } from "../constants";
import { IOccurrence } from "../types";
import Chip from "./Chip";
import moment from "moment";
import { useIntl } from "react-intl";
import { getSupportSubtopicLabel } from "../getSupportSubtopicLabel";

interface Props {
    onClick: () => void;
    data: IOccurrence;
    disabled?: boolean;
    height: number
}

export const convertMinutesToHours = (minutes?: number) => {
    if (!minutes) {
        return '-'
    };

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours === 0) {
        return `${mins} min`;
    }

    if (mins === 0) {
        return `${hours} h`;
    }

    return `${hours}h ${mins}min`;
};

const ClampedText = ({ text }: { text: string }) => {
    return (
        <span
            className="text-size-12 text-normal"
            title={text}
            style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                wordBreak: 'break-word',
            }}
        >
            {text}
        </span>
    );
};

const BoardItem = ({ onClick, data, disabled, height }: Props) => {
    const intl = useIntl();
    const subjectLabel = typeSubjectOccorence[data?.subject?.toUpperCase() as keyof typeof typeSubjectOccorence] || '-';
    const subtopicLabel = getSupportSubtopicLabel(data.subtopic);
    const shouldShowTheme = data.subject !== SupportType.COMMERCIAL
        && data.subject !== SupportType.CONTRACT_CANCELLATION
        && data.supportType !== "TECHNICAL_SUPPORT";

    return (
        <div className={`bg-white flex-1-1 border rounded rounded-small padding-10 ${disabled ? '' : 'cursor-pointer'} height-lg-300`} style={{ borderColor: '#344054', height: height }} onClick={() => disabled ? null : onClick()}>
            <div className="border border-bottom-only" style={{ paddingBottom: 8 }}>
                <div className="display-flex">
                    <span className="text-medium text-size-14 width-50pct">{data?.tasOccurrenceNumber || '-'}</span>
                    <span className="text-size-14 width-50pct text-right">{data?.licensePlate || '-'}</span>
                </div>
                <span className="text-size-14 flex align-items-center gap-4">
                    <span className="rioglyph rioglyph-businessman text-size text-color-gray" />
                    <span>{data?.dn || '-'}</span>
                </span>
                {data?.chassis ? (
                    <span className="text-size-14 flex align-items-center gap-4">
                        <span className="rioglyph rioglyph-truck text-size text-color-gray" />
                        <span>{data?.chassis || '-'}</span>
                    </span>
                ) : null}
            </div>
            <div className="display-flex gap-4" style={{ paddingTop: 8 }}>
                <div className="width-50pct border rounded" style={{ padding: 8, minWidth: 0 }}>
                    <div><Chip type={data?.supportType} /></div>
                    <div className="margin-top-4 display-grid">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Assunto:</span>
                        <ClampedText text={subjectLabel} />
                    </div>
                    <div className="margin-top-4 border border-top-only display-grid">
                        {shouldShowTheme ? (<>
                            <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Tema:</span>
                            <ClampedText text={subtopicLabel} />
                        </>) : null}
                    </div>
                </div>
                <div className="width-50pct rounded" style={{ background: 'rgba(2, 106, 162, 0.04)', padding: 8, minWidth: 0 }} >
                    <div className="border border-bottom-only display-grid padding-bottom-4">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Proprietário:</span>
                        <span className="text-size-12 text-normal">{data?.responsible || '-'}</span>
                    </div>
                    <div className="border border-bottom-only display-grid padding-y-4">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Atribuído á</span>
                        <span className="text-size-12 text-normal">{data.assignedTo || '-'}</span>
                    </div>
                    <div className="border border-bottom-only display-grid padding-y-4">
                        <span className="text-size-12 text-normal">
                            {data.status === 'FINISHED' ?
                                data?.timeInTasOccurrence ? `${convertMinutesToHours(data?.timeInTasOccurrence)} neste chamado` : '-' :
                                data?.timeInStatus ? `${convertMinutesToHours(data?.timeInStatus)} nesta etapa` : '-'
                            }
                        </span>
                    </div>
                    <div className="display-flex margin-top-4 gap-0">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>{intl.formatMessage({ id: "intl-msg:tas.occurrence.updatedAt" })}: </span>
                        <span className="text-size-12 text-normal">{data?.updatedAt ? moment(data?.updatedAt).format("DD/MM/YYYY HH:mm") : '-'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default BoardItem;
